// removed by extract-text-webpack-plugin
module.exports = {"foreignPropertyRow":"_3ZZKsA0_h8HqGI2RqcMeOX","propertyDescription":"_2lpsReCBpRHIxKaOqhRqjw","iconsWrapper":"_3glmFtbdj5rI9ki8SGvxmG","labelNew":"Ndf8x1aPGUptDxoPmJjq4","labelTop":"ua7vljK0gfkgRyqjU0Xsm","propertyType":"_21g1r8S05IcVwt0xJQYK8j","propertyAddress":"_3VeB7WPjL4qP1cr07bSMk4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/OMBaseVerticalForeignPropertyCell/OMBaseVerticalForeignPropertyCell.scss
// module id = 1668
// module chunks = 0